import React from 'react';
import './Footer.css';  
const Footer = () => {
  return (
    <footer className="footer" id='findus'>
      <div className="footer-section">
        <div> 
        <img id='black' src='/Assets/ewe-dark.png'></img>
        </div>
      </div>
      <div className="footer-section">
        <h3>Location</h3>
        <p>34 Scarbrough Avenue, Lincolnshire, PE25 2TA, United Kingdom</p>
      </div>
      <div className="footer-section">
        <h3>Contact Info</h3>
        <p>Email: info@moonsidehotel.co.uk</p>
        <p>Phone: 0175 476 5119</p>
      </div>
      
    </footer>
  );
};

export default Footer;
